// La rejilla del rol por sede: una fila por horario y una columna por cada cancha de cada
// sede. Dos sedes con una cancha del mismo nombre ("Cancha 1") son dos columnas.
//
// ESPEJO del Club (myklubb-control/src/lib/rejillaSedes.js), con la misma prueba: se copia
// byte a byte. JS puro, sin importar nada de este repo. Si tocas una, toca la otra.
//
// Lee `sede`, `campo` y `hora` de cada partido (la forma de get_rol_jornada).

export const SIN_SEDE = 'Sin sede'
export const SIN_CANCHA = 'Sin cancha'

export const ordenNatural = (a, b) =>
  String(a).localeCompare(String(b), 'es', { numeric: true, sensitivity: 'base' })

const horaCorta = (h) => (h ? String(h).slice(0, 5) : '')

// -> { sedes: [{ nombre, canchas }], columnas: [{ sede, cancha }], filas: [{ hora, celdas }] }
// `celdas[i]` son los partidos de `columnas[i]` en esa hora (casi siempre uno).
export function rejillaPorSede(juegos, { ordenSedes = [] } = {}) {
  const lista = (juegos || []).filter(Boolean)
  if (lista.length === 0) return { sedes: [], columnas: [], filas: [] }

  const sedeDe = (j) => j.sede || SIN_SEDE
  const canchaDe = (j) => j.campo || SIN_CANCHA

  const canchasPorSede = new Map()
  lista.forEach((j) => {
    const s = sedeDe(j)
    if (!canchasPorSede.has(s)) canchasPorSede.set(s, new Set())
    canchasPorSede.get(s).add(canchaDe(j))
  })

  const enOrden = (ordenSedes || []).filter((n) => canchasPorSede.has(n) && n !== SIN_SEDE)
  const resto = [...canchasPorSede.keys()]
    .filter((n) => !enOrden.includes(n) && n !== SIN_SEDE)
    .sort(ordenNatural)
  const nombres = [...new Set([...enOrden, ...resto])]
  if (canchasPorSede.has(SIN_SEDE)) nombres.push(SIN_SEDE)

  const sedes = nombres.map((nombre) => {
    const todas = [...canchasPorSede.get(nombre)]
    const reales = todas.filter((c) => c !== SIN_CANCHA).sort(ordenNatural)
    return { nombre, canchas: todas.includes(SIN_CANCHA) ? [...reales, SIN_CANCHA] : reales }
  })

  const columnas = sedes.flatMap((s) => s.canchas.map((cancha) => ({ sede: s.nombre, cancha })))

  const porHora = new Map()
  lista.forEach((j) => {
    const h = horaCorta(j.hora)
    if (!porHora.has(h)) porHora.set(h, [])
    porHora.get(h).push(j)
  })

  const horas = [...porHora.keys()].sort((a, b) => {
    if (a === '' && b !== '') return 1
    if (b === '' && a !== '') return -1
    return a.localeCompare(b)
  })

  const filas = horas.map((hora) => ({
    hora,
    celdas: columnas.map((c) =>
      porHora.get(hora).filter((j) => sedeDe(j) === c.sede && canchaDe(j) === c.cancha)),
  }))

  return { sedes, columnas, filas }
}
